import React, { useState, useEffect, useCallback } from 'react'
import {
  requestProductGroups,
  requestProductGroupsUpdate,
  requestProductGroupsCreate,
} from 'requests/product-groups'
import { newProductGroup } from 'constants/objects/product-group'
import { PRODUCTS_SUBMENU } from 'constants/menu/submenus'
import { ListPage } from 'templates/ListPage'
import { SideMenu } from 'components/SideMenu'
import { ProductGroup } from './components/ProductGroup'
import { Form } from './components/Form'

export default function ProductGroupsList() {
  const [groups, setGroups] = useState([])
  const [responseError, setResponseError] = useState()
  const [pagination, setPagination] = useState()
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [currentGroup, setCurrentGroup] = useState(null)
  const [saving, setSaving] = useState(false)

  const getGroups = useCallback(async () => {
    const response = await requestProductGroups()
    setLoading(false)

    if (response.error) return setResponseError(response)

    setPagination(response.meta?.pagination)
    return setGroups(response.data)
  }, [])

  useEffect(() => {
    getGroups()
  }, [getGroups])

  const onGroupUpdate = async (params) => {
    setSaving(true)
    const resp = await requestProductGroupsUpdate(
      currentGroup.id,
      params,
    )

    setSaving(false)
    if (resp.error) return setResponseError(resp)

    setShowForm(false)
    setCurrentGroup(null)
    return getGroups()
  }

  const onGroupCreate = async (params) => {
    setSaving(true)
    const resp = await requestProductGroupsCreate(params)

    setSaving(false)
    if (resp.error) return setResponseError(resp)

    setShowForm(false)
    return getGroups()
  }

  const onSave = (params) => {
    if (!currentGroup?.id) {
      return onGroupCreate(params)
    }

    return onGroupUpdate(params)
  }

  const onSelectGroup = (category) => {
    setCurrentGroup(category)
    setShowForm(true)
  }

  const onToggleForm = (show = false) => {
    if (!show) setCurrentGroup(null)
    setResponseError(null)
    setShowForm(show)
  }

  const renderForm = () => (
    <Form
      group={currentGroup || newProductGroup}
      onCancel={() => onToggleForm(false)}
      onSave={onSave}
      saving={saving}
      responseError={responseError}
    />
  )

  const renderMenu = () => (
    <SideMenu submenu={PRODUCTS_SUBMENU} />
  )

  const renderGroup = (group) => (
    <ProductGroup
      key={`product-group-list-${group.id}`}
      group={group}
      onClick={onSelectGroup}
    />
  )

  return (
    <ListPage
      renderForm={renderForm}
      renderMenu={renderMenu}
      listTitle="Grupo de produtos"
      onClickPagination={() => {}}
      pagination={pagination}
      loading={loading}
      showForm={showForm}
      onToggleForm={onToggleForm}
      showAddButton
    >
      { groups.map(renderGroup) }
    </ListPage>
  )
}
